import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ChevronDown } from "lucide-react";

const LANGS = [
  { code: "fr", label: "FR", flag: "🇫🇷" },
  { code: "en", label: "EN", flag: "🇬🇧" },
  { code: "de", label: "DE", flag: "🇩🇪" },
  { code: "zh-CN", label: "中文", flag: "🇨🇳" },
];

export default function LanguageSwitcher({ compact = false }) {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const current = LANGS.find(l => l.code === i18n.language) || LANGS[0];

  const change = (code) => {
    i18n.changeLanguage(code);
    document.documentElement.lang = code;
    setOpen(false);
  };

  return (
    <div className="relative" data-testid="lang-switcher">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-1.5 text-[11px] tracking-[0.2em] uppercase text-[#F8F5EF]/80 hover:text-[#D4AF37] transition-colors py-2"
        data-testid="lang-switcher-button"
      >
        <span className="text-base leading-none" aria-hidden="true">{current.flag}</span>
        <span>{current.label}</span>
        <ChevronDown size={12} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute right-0 top-full mt-2 z-50 bg-[#0A0A0A] border border-[#D4AF37]/30 min-w-[150px] shadow-xl">
            {LANGS.map(l => (
              <button
                key={l.code}
                onClick={() => change(l.code)}
                data-testid={`lang-option-${l.code}`}
                className={`flex items-center gap-2.5 w-full text-left px-4 py-3 text-xs tracking-[0.2em] uppercase border-b border-[#D4AF37]/10 last:border-0 transition-colors ${
                  l.code === current.code ? "text-[#D4AF37] bg-[#D4AF37]/5" : "text-[#F8F5EF] hover:bg-[#D4AF37]/5 hover:text-[#D4AF37]"
                }`}
              >
                <span className="text-base leading-none" aria-hidden="true">{l.flag}</span>
                <span>{l.label}</span>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
